/**
 * IMPORTS
 */
import {gql} from '@apollo/client';


/**
 * EXPORTS
 */

/**
 * I am a query to fetch tags.
 */
export const FETCH_TAGS = gql`
query tags ($company: Int!) {
    tags (company: $company) {
        name
        id
        company
    }
}
`;
